import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "../shared/Header";
import SideNav from "../shared/SideNav";
import Footer from "../shared/Footer";
import Backdrop from "../shared/Backdrop";

import useWindowSize from "../hooks/useWindowSize";

import classes from "./MainLayout.module.css";

const MainLayout = () => {
  const { width } = useWindowSize();

  const [openNav, setOpenNav] = useState(width > 810);

  useEffect(() => {
    if (width > 810) {
      setOpenNav(true);
    } else {
      setOpenNav(false);
    }
  }, [width]);

  const handleToggleNav = (): void => {
    setOpenNav(!openNav);
  };

  const handleCloseNav = (): void => {
    setOpenNav(false);
  };

  return (
    <div className={classes.appContainer}>
      <Header onClickNav={handleToggleNav} />
      <main className={classes.main}>
        <SideNav openNav={openNav} />
        <section className={classes.displaySection}>
          <Outlet />
          <Backdrop openNav={openNav} onClickNav={handleCloseNav} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
